import { module } from 'modujs'
import lottie from 'lottie-web'
import { CUSTOM_EVENT, ENV } from '../config'

export default class Loader extends module {

    static get settings() {
        return {
            CLASS_HIDDEN: 'is-hidden',
        }
    }

    constructor(m) {
        super(m)

        // DOM
        this.$el = this.el
        this.$icon = this.$('icon')[0]
    }

    init() {

        if(!ENV.REDUCED_MOTION) {
            this.iconAnimation = lottie.loadAnimation({
                container: this.$icon,
                path: '/assets/lottie/icon.json',
                renderer: 'svg',
                loop: true,
                autoplay: false,
            })
        }

        this.start()

        window.addEventListener(CUSTOM_EVENT.READY, this.onReady = () => this.stop())
    }

    start() {
        this.$el.classList.remove(Loader.settings.CLASS_HIDDEN)
        this.iconAnimation?.play()
    }

    stop() {
        this.$el.classList.add(Loader.settings.CLASS_HIDDEN)
        this.iconAnimation?.pause()
    }
}
